import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { addIntlProps, addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import {
  bodyStyle,
  seriesModelsForBodyStyle,
} from 'reducers/bodyStyles/selectors';
import { currentBrand } from 'reducers/dashboard/selectors';
import { seriesBodyStyleDescription } from 'reducers/seriesPipeline/selectors';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';

const mapStateToProps = combineSelectors({
  bodyStyle,
  currentBrand,
  seriesBodyStyleDescription,
  seriesModelsForBodyStyle,
});

export const name = ({
  seriesBodyStyleDescription,
  totalString,
  currentBrand,
}) => {
  return currentBrand !== 'MI' && seriesBodyStyleDescription
    ? seriesBodyStyleDescription
    : totalString;
};

export const totalUnits = ({ seriesModelsForBodyStyle }) => {
  let total = 0;
  seriesModelsForBodyStyle.forEach(model => {
    total += parseInt(model.quota, 10) || 0;
  });
  return total;
};

export const totalSubmitted = ({ seriesModelsForBodyStyle }) => {
  let total = 0;
  seriesModelsForBodyStyle.forEach(model => {
    total += parseInt(model.quota - model.unsubmitted, 10) || 0;
  });
  return total;
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['totalString'],
  }),
  connect(mapStateToProps),
  addProps({ name, totalUnits, totalSubmitted }),
);
